module.exports = __webpack_public_path__ + "img/mt.c419230.svg";